export enum EnvironmentFilter {
  InsuranceFilter = 'insuranceFilter',
  SupportFilter = 'supportFilter',
  HouseholdPersonsFilter = 'householdPersonsFilter',
  StateFilter = 'stateFilter',
  ZipcodeFilter = 'zipcodeFilter',
  HouseholdIncomeFilter = 'householdIncomeFilter',
  AgeFilter = 'ageFilter',
}
